import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Component, ReactNode } from 'react';
import { IBranchesModalItem } from '../../BranchesModal';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { branchStore } from 'src/mobx/branchStore';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { BRANCHES_MODAL_FETCH_PARAMETER, UNAVAILABLE_BRANCHES_FLAG } from 'src/types/branches';
import { getTranslate, getUnavailable } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Spinner from 'src/view/components/Controls/Spinner/Spinner';
import { IBranchesModalParams } from '~/mobx/modalStore/types';
import './style.scss';

interface IProps extends IBranchesModalParams {
  disabled?: boolean;
  iconSize?: number;
  className?: string;
  titleClassName?: string;
  showIconPlaceholder?: boolean;
  children?: ReactNode;
}

@observer
export default class BranchesModalOpen extends Component<IProps, {}> {
  static defaultProps = {
    selectedBranches: [],
    fetchParamStatus: BRANCHES_MODAL_FETCH_PARAMETER.ALL,
    fetchParamDelete: BRANCHES_MODAL_FETCH_PARAMETER.ACTIVE,
    checkUnavailable: false,
    unavailableFlag: UNAVAILABLE_BRANCHES_FLAG.ALL,
    highlightUnavailable: true,
  };

  onOpen = () => {
    if (this.props.disabled) return;
    modalStore.openBranchesModal({ ...this.props, onSave: this.onSave });
  };

  onSave = (branches: IBranchesModalItem[]) => {
    this.props.onSave(branches);
    modalStore.closeBranchesModal();
  };

  get selectedUnavailableLength(): number {
    if (!this.props.checkUnavailable) return 0;
    return this.props.selectedBranches.filter((branch) => getUnavailable(branch, this.props.unavailableFlag)).length;
  }

  get placeholder(): string {
    const defaultPlaceholder: string = localeStore.t('branches');
    const length: number = this.props.selectedBranches.length - this.selectedUnavailableLength;

    if (!length) {
      return defaultPlaceholder;
    } else if (length === 1) {
      return getTranslate(this.props.selectedBranches[0].name) || defaultPlaceholder;
    }

    return `${length} ${localeStore.t('select_branches')} ${localeStore.t('selected').toLowerCase()}`;
  }

  render() {
    return (
      <div className={classNames('custom-modal__open branches-modal-open', this.props.className)} onClick={this.onOpen}>
        {this.props.children ? (
          this.props.children
        ) : (
          <>
            <div className="d-flex align-items-center gap-15">
              {this.props.showIconPlaceholder && <Icon name={Icons.BranchesTree} size={20} color={theme.colors.mainblue} />}
              <p className={classNames('branches-modal-open__title', this.props.titleClassName)}>{this.placeholder}</p>
            </div>
            {branchStore.branches?.length < 1 ? (
              <Spinner color={theme.colors.gray} />
            ) : (
              <Icon name={Icons.Chevron} size={this.props.iconSize || 20} color={theme.colors.gray2} />
            )}
          </>
        )}
      </div>
    );
  }
}
